export interface IAddress {
  city: string
  postal_code: string
  state: string
  street: string
}

export function addressFactory(data?: IAddress): IAddress {
  return {
    city: data?.city || '',
    postal_code: data?.postal_code || '',
    state: data?.state || '',
    street: data?.street || '',
  }
}
